import script from "./ModerationCaseBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ModerationCaseBox.vue?vue&type=script&setup=true&lang=js"

import "./ModerationCaseBox.vue?vue&type=style&index=0&id=bc7eb8c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc7eb8c2"]])

export default __exports__